<template>
  <UIModal
    v-model="isOpen"
    blured
    :close-button="!isProcessing"
    :close-on-click-outside="!isProcessing"
    @closed="emit('closed')"
  >
    <!-- Header -->
    <template #header>
      <h2 class="halloween-expedition-modal__title">{{ $t('HalloweenExpeditionFinalModalTitle') }}</h2>
      <!-- <h2 class="halloween-expedition-modal__title">{{ $t('HalloweenExpeditionFailureModalTitle') }}</h2> -->
    </template>

    <!-- Content -->
    <div class="halloween-expedition-modal__content">
      <div class="halloween-expedition-modal__cross-img">
        <img src="/img/sideBar/icon_halloweenExpedition_1.png" alt="torch" />
      </div>
      <!-- <div class="halloween-expedition-modal__cross-img">
        <img src="/img/halloween/items/cross.png" alt="cross" />
      </div> -->

      <div class="halloween-expedition-modal__text">
        <!-- <p>{{ $t('HalloweenExpeditionFailureModalText1') }}</p>
        <p>{{ $t('HalloweenExpeditionFailureModalText2') }}</p> -->
        <p>{{ $t('HalloweenExpeditionFinalModalText1') }}</p>
      </div>
    </div>

    <!-- Footer -->
    <template #footer>
      <div class="halloween-expedition-modal__footer">
        <HalloweenGenericButton :disabled="isProcessing" @click="continueAction">
          {{ $t('coreContinue') }}
        </HalloweenGenericButton>
      </div>
    </template>
  </UIModal>
</template>

<script setup lang="ts">
const isOpen = defineModel<boolean>({ default: false });

const isProcessing = ref(false);
const emit = defineEmits(['closed']);

const continueAction = async () => {
  isOpen.value = false;
  emit('closed');
};
</script>

<style lang="scss" scoped>
.halloween-expedition-modal {
  &__title {
    font-family: 'PT Serif', serif;
    font-size: 32px;
    font-weight: bold;
    line-height: 30px;
    color: #ffffff;
    text-align: center;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 8px;

    @media (min-width: 640px) {
      padding-left: 48px;
      padding-right: 48px;
    }
  }

  &__content {
    font-family: 'PT Serif', serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 110%;
    text-align: center;
    color: #dedede;
    padding-left: 24px;
    padding-right: 24px;

    max-width: 600px;
    margin: 0 auto;

    @media (min-width: 640px) {
      padding-left: 48px;
      padding-right: 48px;
    }

    @media screen and (max-width: 640px) {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  &__text {
    margin-bottom: 20px;

    p {
      margin-bottom: 4px;
    }
  }

  &__cross-img {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    img {
      max-width: 180px;
      width: 100%;
      height: auto;
      display: block;
    }
  }

  &__footer {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
}
</style>
